var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-nav-item', {
    staticClass: "nav-item",
    class: {
      closed: !_vm.isOpen
    },
    attrs: {
      "to": _vm.to,
      "exact": _vm.exact,
      "active-class": "active",
      "exact-active-class": "active"
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._t("icon"), _c('span', {
    staticClass: "navbar-item-label",
    class: {
      visible: _vm.isOpen
    }
  }, [_vm._v(_vm._s(_vm.title))])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }